var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalAd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 0H6C4.4087 0 2.88258 0.632141 1.75736 1.75736C0.632141 2.88258 0 4.4087 0 6V26C0 27.5913 0.632141 29.1174 1.75736 30.2426C2.88258 31.3679 4.4087 32 6 32H12V36H6C5.46957 36 4.96086 36.2107 4.58579 36.5858C4.21071 36.9609 4 37.4696 4 38C4 38.5304 4.21071 39.0391 4.58579 39.4142C4.96086 39.7893 5.46957 40 6 40H34C34.5304 40 35.0391 39.7893 35.4142 39.4142C35.7893 39.0391 36 38.5304 36 38C36 37.4696 35.7893 36.9609 35.4142 36.5858C35.0391 36.2107 34.5304 36 34 36H28V32H34C35.5913 32 37.1174 31.3679 38.2426 30.2426C39.3679 29.1174 40 27.5913 40 26V6C40 4.4087 39.3679 2.88258 38.2426 1.75736C37.1174 0.632141 35.5913 0 34 0ZM24 36H16V32H24V36ZM36 26C36 26.5304 35.7893 27.0391 35.4142 27.4142C35.0391 27.7893 34.5304 28 34 28H6C5.46957 28 4.96086 27.7893 4.58579 27.4142C4.21071 27.0391 4 26.5304 4 26V24H36V26ZM36 20H4V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H34C34.5304 4 35.0391 4.21071 35.4142 4.58579C35.7893 4.96086 36 5.46957 36 6V20Z",
    fill: "#FF2828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalAd);
export default __webpack_public_path__ + "static/media/external_ad.200ea4538316333576cab84593cb77bd.svg";
export { ForwardRef as ReactComponent };